import AumeLogo from '@/assets/branding/aume/aume-logo.svg';

export { AumeLogo };
